let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jPNH0")).then(() => parcelRequire('dsTJM'));